import { render, staticRenderFns } from "./CaseEditMember.vue?vue&type=template&id=48ca50e0&scoped=true&lang=pug&"
import script from "./CaseEditMember.vue?vue&type=script&lang=js&"
export * from "./CaseEditMember.vue?vue&type=script&lang=js&"
import style0 from "./CaseEditMember.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CaseEditMember.vue?vue&type=style&index=1&id=48ca50e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ca50e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VForm,VTab,VTabItem,VTabs,VTabsItems})
